export default "__VITE_ASSET__DaHhgeOO__";